import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize, map, switchMap, tap } from 'rxjs/operators';
import { PresenceService } from 'src/app/data/presence.service';
import { Filter } from 'src/app/models/common/filter';
import { PresencePerMonthDto } from 'src/app/models/dtos/presence-per-month-dto';

interface PagingRequest {
    Year: number;
    Month: number;
    Page: number;
    PageSize: number;
    SortingDirection: string;
    SortingField: string;
    Filters: Filter[]
}

export interface PresencePerMonthViewModel extends PresencePerMonthDto {
    OriginCorrectedTotalTimespanDay?: number;
    OriginCorrectedTotalTimespanNight?: number;
    OriginCorrectedWorkedDays?: number;
}

@Injectable({
    providedIn: 'root',
})
export class PresencePerMonthListDataSource {
    private presenceService = inject(PresenceService);

    countSubject = new BehaviorSubject<number>(0);
    count$: Observable<number> = this.countSubject.asObservable();
    isLoadingSubject = new BehaviorSubject<boolean>(false);
    isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();
    pageOptionsSubject = new Subject<PagingRequest>();
    private presencesSubject = new BehaviorSubject<PresencePerMonthViewModel[]>(null);

    presences$: Observable<PresencePerMonthViewModel[]> = this.presencesSubject.asObservable();

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        this.pageOptionsSubject.pipe(
            tap(() => this.isLoadingSubject.next(true)),
            switchMap((request) => this.presenceService.getPresencesPerMonth(request.Year, request.Month, request.Page, request.PageSize, request.SortingField, request.SortingDirection, request.Filters)
                .pipe(finalize(() => this.isLoadingSubject.next(false)))),
            tap((res) => this.countSubject.next(res.Count)),
            map((res) => res.Results as PresencePerMonthViewModel[])
        )
            .subscribe(this.presencesSubject);
    }

    public updateItem(item: PresencePerMonthDto) {
        const list = this.presencesSubject.value;

        if (!list) {
            return;
        }

        const index = list.findIndex(i => i.WorkerAgreementId === item.WorkerAgreementId);

        if (index !== -1) {
            list[index] = item as PresencePerMonthViewModel;

            this.presencesSubject.next([...list]);
        }
    }
}
